import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { errorBoundary, sendTelemetryErrorEvent } from '~commonInfra/components/ErrorBoundary';
import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { requestSpaceContents } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '../../bootstrap/redux/state/AppState';
import {
  PredictiveModelEditorSpace,
  PredictiveModelEditorSpaceDispatchProps,
  PredictiveModelEditorSpaceOwnProps,
  PredictiveModelEditorSpaceStateProps
} from './PredictiveModelEditorSpace';

//Connected space uses state/dispact props to construct the actual props and connect to predictie model space with Redux infra
const mapStateToProps: MapStateToProps<PredictiveModelEditorSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state)
});

const mapDispatchToProps: MapDispatchToProps<PredictiveModelEditorSpaceDispatchProps> = (dispatch) =>
  bindActionCreators({
    requestSpaceContents,
  }, dispatch);

const ConnectedPredictiveModelEditorSpaceInternal: React.ComponentClass<PredictiveModelEditorSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(PredictiveModelEditorSpace);

export const ConnectedPredictiveModelEditorSpace = errorBoundary<PredictiveModelEditorSpaceOwnProps>
  (sendTelemetryErrorEvent)(ConnectedPredictiveModelEditorSpaceInternal);
